// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Address = t.struct({
    city: t.String,
    country: t.String,
    line1: t.String,
    line2: t.String,
    postalCode: t.String,
    state: t.String
}, {
    name: 'Address',
    strict: true
});

export const getDefaultState = () => new Address({
    city: '',
    country: '',
    line1: '',
    line2: '',
    postalCode: '',
    state: ''
});

export default Address;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/address.js